module.exports = __webpack_public_path__ + "300da946d3856739852d505e338b9dc9.jpg";